import { render, staticRenderFns } from "./TrainingScreens.vue?vue&type=template&id=50e4d145&scoped=true&"
import script from "./TrainingScreens.vue?vue&type=script&lang=js&"
export * from "./TrainingScreens.vue?vue&type=script&lang=js&"
import style0 from "./TrainingScreens.vue?vue&type=style&index=0&id=50e4d145&scoped=true&lang=css&"
import style1 from "./TrainingScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4d145",
  null
  
)

export default component.exports